export const list = {
  table: {
    id: 'ID',
    no: 'No.',
    position: 'Position',
    workingForm: 'Working Style',
    workingHours: 'Working Hours',
    department: 'Department',
    code: 'IC code',
    firstName: 'First name',
    lastName: 'Last name',
    name: 'Name',
    kana: 'Kana',
    gender: 'Gender',
    uid: 'IC Card No.',
    language: 'Language',
    companyJoinDate: 'Company join date',
    dob: 'DOB',
    action: 'Action',
    update: 'Update',
    delete: 'Delete',
    confirmDelete: 'Are you sure to delete this employee?',
  },
  pageHeader: {
    title: 'Employees',
    titleEmployeesList: 'Personal data registration/editing',
    new: 'New',
    csvImport: 'CSV Import',
  },
  buttonAction: {
    importAdd: 'Import (Add)',
    importOverwrite: 'import (Overwrite)',
    export: 'Export',
    update: 'Update',
  },
  languages: {
    en: 'English',
    vi: 'Vietnamese',
    th: 'Thai',
    ja: 'Japanese',
    cn: 'Chinese',
  },
}
